<div *ngFor="let item of items" [draggable]="draggable" (dragstart)="startDrag(item)" (dragover)="allowDrop($event)" (drop)="endDrag($event, item)">
  <ng-container *ngTemplateOutlet="customTemplateRef; context: {item: item}"> </ng-container>
</div>
<ng-content></ng-content>
